import * as actionTypes from './messageDialogActionTypes';

export const addInfo = message => ({
  type: actionTypes.MESSAGE_DIALOG_ADD_INFO,
  message,
});

export const addError = message => ({
  type: actionTypes.MESSAGE_DIALOG_ADD_ERROR,
  message,
});

export const dismissAll = () => ({
  type: actionTypes.MESSAGE_DIALOG_DISMISS_ALL,
});

export const addIntlError = message => ({
  type: actionTypes.MESSAGE_DIALOG_ERROR_INTL,
  message,
});

export const addIntlInfo = message => ({
  type: actionTypes.MESSAGE_DIALOG_INFO_INTL,
  message,
});

export const addDisclaimerMessage = message => ({
  type: actionTypes.MESSAGE_DISCLAIMER,
  message,
});
